// extracted by mini-css-extract-plugin
export default {"header":"header__1I7JH","active":"active__36zX-","logo":"logo__2stks","dark":"dark__Glr9y"};